import {
  Card,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  Button,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useOrgConfig } from "~/providers/OrgConfigProvider";
import { useState } from "react";

import Help from "~/components/common/Help";
import PrecautionRow, { PrecautionDialog } from "./PrecautionRow";
import { sortBy } from "lodash";
import { DEFAULT_PRECAUTION_COLOR } from "./precautionColors";

const TabPrecautions = () => {
  const { precautions, loading } = useOrgConfig();

  const [createDialogOpen, setCreateDialogOpen] = useState(false)
  const precautionList = sortBy(Object.values(precautions), "name");

  return (
    <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
      <Card sx={{ height: "100%" }}>
        <TableContainer>
          <Table sx={{ tableLayout: 'fixed' }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: '50%', maxWidth: '400px' }}>
                  Precaution
                  <Help text="Infection-control / isolation precaution that can be applied to a patient's episode (e.g. Contact, Droplet, Airborne). Shown to schedulers and field providers via colored badges." />
                </TableCell>
                <TableCell sx={{ width: '20%', maxWidth: '150px' }}>Description</TableCell>
                <TableCell sx={{ width: '15%', maxWidth: '120px' }}>Status</TableCell>
                <TableCell sx={{ width: '15%', maxWidth: '100px' }}>Active</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <>
                  <RowSkeleton />
                  <RowSkeleton />
                  <RowSkeleton />
                </>
              ) : precautionList.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} sx={{ textAlign: "center" }}>
                    No precautions found
                  </TableCell>
                </TableRow>
              ) : (
                precautionList.map((precaution) => (precaution && <PrecautionRow key={precaution.id} precaution={precaution} />))
              )}
            <TableRow>
              <TableCell colSpan={3}>
                <Button
                  onClick={() => setCreateDialogOpen(true)}
                  size="small"
                  startIcon={<AddCircleOutlineIcon fontSize="small" />}
                >
                  Add New Precaution
                </Button>
              </TableCell>
            </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Card>

      {createDialogOpen && <PrecautionDialog
        precaution={{ id: 0, name: "", color: DEFAULT_PRECAUTION_COLOR, description: "", active: true }}
        onClose={() => setCreateDialogOpen(false)}
      />}
    </Container>
  );
};

export default TabPrecautions;

const RowSkeleton = () => (
  <TableRow>
    <TableCell sx={{ width: '50%', maxWidth: '400px' }}>
      <Skeleton width="100%" />
    </TableCell>
    <TableCell sx={{ width: '20%', maxWidth: '150px' }}>
      <Skeleton width="100%" />
    </TableCell>
    <TableCell sx={{ width: '15%', maxWidth: '120px' }}>
      <Skeleton width="100%" />
    </TableCell>
    <TableCell sx={{ width: '15%', maxWidth: '100px' }}>
      <Skeleton width="100%" />
    </TableCell>
  </TableRow>
);
